import { html } from 'rune-ts';

export const CloseIcon = html`
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none">
    <g clip-path="url(#clip0_132_1042)">
      <path
        d="M13.2583 12.0001L20.7379 4.51006C21.0874 4.16006 21.0874 3.60006 20.7379 3.26006C20.3884 2.91006 19.8291 2.91006 19.4796 3.26006L12 10.7401L4.52039 3.26006C4.17087 2.91006 3.61165 2.91006 3.26214 3.26006C2.91262 3.61006 2.91262 4.17006 3.26214 4.51006L10.7417 12.0001L3.26214 19.4901C2.91262 19.8401 2.91262 20.4001 3.26214 20.7401C3.4319 20.9101 3.66158 21.0001 3.89126 21.0001C4.12094 21.0001 4.34064 20.9101 4.52039 20.7401L12 13.2601L19.4796 20.7401C19.6494 20.9101 19.8791 21.0001 20.1087 21.0001C20.3384 21.0001 20.5581 20.9101 20.7379 20.7401C21.0874 20.3901 21.0874 19.8301 20.7379 19.4901L13.2583 12.0001Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_132_1042">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const ImportantIcon = html`
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 20 20" fill="none">
    <g clip-path="url(#clip0_6030_18975)">
      <path
        d="M9.99935 1.6665C5.39935 1.6665 1.66602 5.39984 1.66602 9.99984C1.66602 14.5998 5.39935 18.3332 9.99935 18.3332C14.5993 18.3332 18.3327 14.5998 18.3327 9.99984C18.3327 5.39984 14.5993 1.6665 9.99935 1.6665ZM11.041 14.0665C11.041 14.6415 10.5743 15.1082 9.99935 15.1082C9.42435 15.1082 8.95768 14.6415 8.95768 14.0665V9.6915C8.95768 9.1165 9.42435 8.64984 9.99935 8.64984C10.5743 8.64984 11.041 9.1165 11.041 9.6915V14.0665ZM9.99935 6.98317C9.42435 6.98317 8.95768 6.5165 8.95768 5.9415C8.95768 5.3665 9.42435 4.89984 9.99935 4.89984C10.5743 4.89984 11.041 5.3665 11.041 5.9415C11.041 6.5165 10.5743 6.98317 9.99935 6.98317Z"
        fill="#6B6B6B"
      />
    </g>
    <defs>
      <clipPath id="clip0_6030_18975">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

export const MarkIcon = html`
  <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
    <circle cx="2" cy="2" r="2" fill="#1C75FF" />
  </svg>
`;

export const ListMarkIcon = html`
  <svg xmlns="http://www.w3.org/2000/svg" width="2" height="2" viewBox="0 0 2 2" fill="none">
    <circle cx="1" cy="1" r="1" fill="#6B6B6B" />
  </svg>
`;

export const FormRowAsteriskIcon = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="4"
  height="4"
  viewBox="0 0 4 4"
  fill="none"
>
  <circle cx="2" cy="2" r="2" fill="#1C75FF" />
</svg>`;

export const DropDownIcon = html`
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M2 4L6 8L10 4" stroke="#141414" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
`;

export const StudioDropDownIcon = html`
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M7.4301 11.6671C7.74672 12.1424 8.44506 12.1424 8.76168 11.6671L13.041 5.24337C13.3952 4.71171 13.014 3.99984 12.3752 3.99984H3.81659C3.17776 3.99984 2.79662 4.71171 3.1508 5.24337L7.4301 11.6671Z"
      fill="#141414"
    />
  </svg>
`;

export const DatePickerCalendarIcon = html`
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
    <g clip-path="url(#clip0_7994_61407)">
      <path
        d="M17.5833 3.54154H15.1083V2.39154C15.1083 1.99154 14.7833 1.6582 14.3749 1.6582C13.9666 1.6582 13.6416 1.9832 13.6416 2.39154V3.54154H7.33327V2.39154C7.33327 1.99154 7.00827 1.6582 6.59994 1.6582C6.1916 1.6582 5.8666 1.9832 5.8666 2.39154V3.54154H3.3916C2.69993 3.54154 2.1416 4.09987 2.1416 4.79154V17.1499C2.1416 17.8082 2.69993 18.3332 3.3916 18.3332H17.5583C18.2499 18.3332 18.8083 17.7999 18.8083 17.1499V4.79154C18.8083 4.09987 18.2499 3.54154 17.5583 3.54154H17.5833ZM12.3749 14.2665H8.62493C8.22493 14.2665 7.8916 13.9415 7.8916 13.5332C7.8916 13.1249 8.2166 12.7999 8.62493 12.7999H12.3749C12.7749 12.7999 13.1083 13.1249 13.1083 13.5332C13.1083 13.9415 12.7833 14.2665 12.3749 14.2665ZM17.3749 8.74987H3.62493V5.41654C3.62493 5.1832 3.80827 4.99987 4.0416 4.99987H5.8916V6.14154C5.8916 6.54154 6.2166 6.87487 6.62493 6.87487C7.03327 6.87487 7.35827 6.54987 7.35827 6.14154V4.99987H13.6666V6.14154C13.6666 6.54154 13.9916 6.87487 14.3999 6.87487C14.8083 6.87487 15.1333 6.54987 15.1333 6.14154V4.99987H16.9833C17.2166 4.99987 17.3999 5.1832 17.3999 5.41654V8.74987H17.3749Z"
        fill="#6B6B6B"
      />
    </g>
    <defs>
      <clipPath id="clip0_7994_61407">
        <rect width="20" height="20" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
`;

export const CheckIcon = html`<svg
  width="100%"
  height="100%"
  viewBox="0 0 15 15"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="3.08716"
    y="7.07153"
    width="1.5"
    height="4"
    transform="rotate(-45 3.08716 7.07153)"
    fill="currentColor"
  />
  <rect
    x="5.91553"
    y="9.8999"
    width="8"
    height="1.5"
    transform="rotate(-45 5.91553 9.8999)"
    fill="currentColor"
  />
</svg>`;

export const IconsBasicHeartLineIconStaticFill = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 44 44"
  fill="none"
>
  <path
    d="M30.6109 10.5417C33.3036 10.5417 35.5201 12.0267 36.5459 14.52C38.5426 19.3967 34.9339 24.8784 33.2487 27.06C28.1929 33.055 23.9248 35.7867 22.0198 36.8317C20.1147 35.805 15.8283 33.055 10.7908 27.06C9.10559 24.8784 5.51527 19.3967 7.49361 14.52C8.51942 12.0267 10.7359 10.5417 13.4286 10.5417C15.81 10.5417 17.8982 11.715 19.0156 13.6584L19.1622 13.8967C19.7666 14.905 20.8657 15.5284 22.0381 15.5284C23.2104 15.5284 24.3095 14.905 24.914 13.8967L25.0605 13.6584C26.1779 11.6967 28.2662 10.5417 30.6475 10.5417M30.6109 7.33337C27.3136 7.33337 24.0347 8.94671 22.2396 12.0634C22.2029 12.1184 22.1663 12.1917 22.1297 12.2467C22.1113 12.2834 22.0564 12.32 22.0014 12.32C21.9465 12.32 21.9098 12.3017 21.8732 12.2467C21.8366 12.1917 21.7999 12.1184 21.7633 12.0634C19.9865 8.94671 16.6892 7.33337 13.392 7.33337C9.76504 7.33337 6.13808 9.27671 4.48947 13.31C2.27299 18.7367 4.87414 24.7317 8.26297 29.0767C15.0772 37.18 20.6276 39.8017 21.7816 40.2967C21.8549 40.3334 21.9282 40.3334 22.0014 40.3334C22.0747 40.3334 22.148 40.3334 22.2212 40.2967C23.3753 39.82 28.9073 37.1984 35.7399 29.0767C39.1104 24.7317 41.7299 18.7367 39.5134 13.31C37.8648 9.27671 34.2378 7.33337 30.6109 7.33337Z"
    fill="white"
  />
</svg>`;

export const IconsBasicHeartGrayIconStaticFill = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 17 16"
  fill="none"
>
  <path
    d="M14.8548 4.83984C14.2553 3.37317 12.9364 2.6665 11.6175 2.6665C10.4186 2.6665 9.22622 3.25317 8.57344 4.3865C8.56012 4.4065 8.54679 4.43317 8.53347 4.45317C8.52015 4.47317 8.50683 4.47984 8.48684 4.47984C8.46686 4.47984 8.45354 4.47317 8.44022 4.45317C8.4269 4.43317 8.41357 4.4065 8.40025 4.3865C7.75413 3.25317 6.55513 2.6665 5.35614 2.6665C4.05057 2.6665 2.73167 3.37317 2.13218 4.83984C1.32619 6.81317 2.27206 8.99317 3.50436 10.5732C5.98228 13.5198 8.00059 14.4732 8.42023 14.6532C8.47352 14.6732 8.52681 14.6732 8.5801 14.6532C8.99975 14.4798 11.0114 13.5265 13.496 10.5732C14.7216 8.99317 15.6741 6.81317 14.8682 4.83984H14.8548Z"
    fill="#D9D9D9"
  />
</svg>`;

export const IconsBasicHeartBlueIconStaticFill = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 17 16"
  fill="none"
>
  <path
    d="M14.8548 4.83984C14.2553 3.37317 12.9364 2.6665 11.6175 2.6665C10.4186 2.6665 9.22622 3.25317 8.57344 4.3865C8.56012 4.4065 8.54679 4.43317 8.53347 4.45317C8.52015 4.47317 8.50683 4.47984 8.48684 4.47984C8.46686 4.47984 8.45354 4.47317 8.44022 4.45317C8.42689 4.43317 8.41357 4.4065 8.40025 4.3865C7.75413 3.25317 6.55513 2.6665 5.35614 2.6665C4.05057 2.6665 2.73167 3.37317 2.13218 4.83984C1.32619 6.81317 2.27206 8.99317 3.50436 10.5732C5.98228 13.5198 8.00059 14.4732 8.42023 14.6532C8.47352 14.6732 8.52681 14.6732 8.5801 14.6532C8.99975 14.4798 11.0114 13.5265 13.496 10.5732C14.7216 8.99317 15.6741 6.81317 14.8682 4.83984H14.8548Z"
    fill="#1C75FF"
  />
</svg>`;

export const HeartLineIcon = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 44 44"
  fill="none"
>
  <path
    d="M30.6109 10.5417C33.3036 10.5417 35.5201 12.0267 36.5459 14.52C38.5426 19.3967 34.9339 24.8784 33.2487 27.06C28.1929 33.055 23.9248 35.7867 22.0198 36.8317C20.1147 35.805 15.8283 33.055 10.7908 27.06C9.10559 24.8784 5.51527 19.3967 7.49361 14.52C8.51942 12.0267 10.7359 10.5417 13.4286 10.5417C15.81 10.5417 17.8982 11.715 19.0156 13.6584L19.1622 13.8967C19.7666 14.905 20.8657 15.5284 22.0381 15.5284C23.2104 15.5284 24.3095 14.905 24.914 13.8967L25.0605 13.6584C26.1779 11.6967 28.2662 10.5417 30.6475 10.5417M30.6109 7.33337C27.3136 7.33337 24.0347 8.94671 22.2396 12.0634C22.2029 12.1184 22.1663 12.1917 22.1297 12.2467C22.1113 12.2834 22.0564 12.32 22.0014 12.32C21.9465 12.32 21.9098 12.3017 21.8732 12.2467C21.8366 12.1917 21.7999 12.1184 21.7633 12.0634C19.9865 8.94671 16.6892 7.33337 13.392 7.33337C9.76504 7.33337 6.13808 9.27671 4.48947 13.31C2.27299 18.7367 4.87414 24.7317 8.26297 29.0767C15.0772 37.18 20.6276 39.8017 21.7816 40.2967C21.8549 40.3334 21.9282 40.3334 22.0014 40.3334C22.0747 40.3334 22.148 40.3334 22.2212 40.2967C23.3753 39.82 28.9073 37.1984 35.7399 29.0767C39.1104 24.7317 41.7299 18.7367 39.5134 13.31C37.8648 9.27671 34.2378 7.33337 30.6109 7.33337Z"
    fill="currentColor"
  />
</svg>`;

export const HeartActiveIcon = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 27 26"
  fill="none"
>
  <path
    d="M23.8272 7.86492C22.853 5.48159 20.7098 4.33325 18.5666 4.33325C16.6183 4.33325 14.6807 5.28659 13.6199 7.12825C13.5983 7.16075 13.5767 7.20409 13.555 7.23659C13.5334 7.26909 13.5117 7.27992 13.4792 7.27992C13.4468 7.27992 13.4251 7.26909 13.4035 7.23659C13.3818 7.20409 13.3602 7.16075 13.3385 7.12825C12.2886 5.28659 10.3402 4.33325 8.39184 4.33325C6.27028 4.33325 4.12708 5.48159 3.1529 7.86492C1.84317 11.0716 3.38021 14.6141 5.38269 17.1816C9.40932 21.9699 12.6891 23.5191 13.371 23.8116C13.4576 23.8441 13.5442 23.8441 13.6308 23.8116C14.3127 23.5299 17.5816 21.9808 21.6191 17.1816C23.6107 14.6141 25.1586 11.0716 23.8489 7.86492H23.8272Z"
    fill="currentColor"
  />
</svg>`;

export const TrophySolidIcon = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 16 17"
  fill="none"
>
  <g clip-path="url(#clip0_22984_26803)">
    <path
      d="M11.993 8.51984C13.473 8.12651 14.6663 6.94651 14.6663 3.85984C14.6663 3.42651 14.3863 3.05984 13.9997 3.05984H12.193V2.54651C12.193 2.15318 11.873 1.83984 11.4863 1.83984H4.51301C4.11967 1.83984 3.80634 2.15984 3.80634 2.54651V3.05984H1.99967C1.61301 3.05984 1.33301 3.42651 1.33301 3.85984C1.33301 6.94651 2.52634 8.13318 4.00634 8.51984C4.49301 9.99318 5.81967 11.0798 7.41967 11.2132V13.9998H5.25301C4.93301 13.9998 4.66634 14.2598 4.66634 14.5865C4.66634 14.9132 4.92634 15.1732 5.25301 15.1732H10.753C11.073 15.1732 11.3397 14.9132 11.3397 14.5865C11.3397 14.2598 11.0797 13.9998 10.753 13.9998H8.58634V11.2132C10.1863 11.0798 11.513 9.99318 11.9997 8.51984H11.993ZM13.493 4.21984C13.4263 5.99318 12.8997 6.81318 12.193 7.19318V4.21984H13.493ZM2.50634 4.21984H3.80634V7.19318C3.09967 6.81318 2.57301 5.99318 2.50634 4.21984Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_22984_26803">
      <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>`;

export const IconBasicCloseMIcon = html`<svg
  width="100%"
  height="100%"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_5078_26023)">
    <path
      d="M3.26603 3.26381C3.61737 2.91283 4.18713 2.91285 4.53849 3.26381L12.0004 10.7267L19.4623 3.26381L19.5317 3.20131C19.8851 2.91336 20.4064 2.93443 20.7358 3.26381C21.0651 3.59317 21.0861 4.1144 20.7983 4.46792L20.7358 4.53725L13.2729 11.9992L20.7397 19.4669L20.8022 19.5363C21.0901 19.8897 21.0689 20.411 20.7397 20.7404C20.4103 21.0698 19.889 21.0909 19.5356 20.8029L19.4662 20.7404L12.0004 13.2726L4.53458 20.7404C4.18319 21.0915 3.6135 21.0915 3.26212 20.7404C2.91067 20.3889 2.91067 19.8184 3.26212 19.4669L10.727 11.9992L3.26603 4.53725C2.91459 4.18576 2.91458 3.61531 3.26603 3.26381Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_5078_26023">
      <rect width="24" height="24" fill="white" />
    </clipPath>
  </defs>
</svg> `;

export const SnsSimpleInstagramIcon = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 24 24"
  fill="none"
>
  <g clip-path="url(#clip0_5120_26056)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.26 3H15.73C18.64 3 20.99 5.36 20.99 8.26V15.73C20.99 18.64 18.63 20.99 15.73 20.99H8.26C5.35 20.99 3 18.63 3 15.73V8.26C3 5.35 5.36 3 8.26 3ZM15.74 4.7H8.27C6.3 4.7 4.7 6.3 4.7 8.27V15.74C4.7 17.71 6.3 19.31 8.27 19.31H15.74C17.71 19.31 19.31 17.71 19.31 15.74V8.27C19.31 6.3 17.71 4.7 15.74 4.7Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.58 11.97C16.58 9.42 14.51 7.35 11.96 7.35C9.41 7.35 7.34 9.42 7.34 11.97C7.34 14.52 9.41 16.59 11.96 16.59C14.51 16.59 16.58 14.52 16.58 11.97ZM9.04 11.97C9.04 10.36 10.35 9.05 11.96 9.05C13.57 9.05 14.88 10.36 14.88 11.97C14.88 13.58 13.57 14.89 11.96 14.89C10.35 14.89 9.04 13.58 9.04 11.97Z"
      fill="currentColor"
    />
    <path
      d="M16.79 8.3C17.392 8.3 17.88 7.81199 17.88 7.21C17.88 6.60801 17.392 6.12 16.79 6.12C16.188 6.12 15.7 6.60801 15.7 7.21C15.7 7.81199 16.188 8.3 16.79 8.3Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_5120_26056">
      <rect width="24" height="24" fill="white" />
    </clipPath>
  </defs>
</svg>`;

export const ThumbnailAdult18Icon = html`<svg
  width="100%"
  height="100%"
  viewBox="0 0 280 280"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect x="3" y="3" width="274" height="274" rx="137" fill="#F5F5F5" />
  <rect x="3" y="3" width="274" height="274" rx="137" stroke="#D9D9D9" stroke-width="6" />
  <path
    d="M140.718 189.371C123.026 189.371 114.249 180.457 114.249 163.863V158.514C114.249 148.777 117.403 141.097 126.18 137.531V137.394C118.775 134.103 114.935 126.971 114.935 118.194V115.04C114.935 99.5429 123.575 90.6286 140.718 90.6286C157.86 90.6286 166.5 99.5429 166.5 115.04V118.194C166.5 126.971 162.523 134.103 155.255 137.394V137.531C164.169 141.097 167.049 148.777 167.049 158.514V163.863C167.049 180.457 158.409 189.371 140.718 189.371ZM140.718 131.086C146.752 131.086 151.14 127.794 151.14 120.114V115.451C151.14 108.183 147.575 104.48 140.718 104.48C133.998 104.48 130.432 108.183 130.432 115.451V120.114C130.432 127.794 134.683 131.086 140.718 131.086ZM140.718 175.52C148.26 175.52 151.689 171.68 151.689 162.903V157.143C151.689 149.051 147.849 144.937 140.718 144.937C133.586 144.937 129.883 149.051 129.883 157.143V162.903C129.883 171.68 133.175 175.52 140.718 175.52Z"
    fill="#D9D9D9"
  />
  <path
    d="M87.055 188.001V114.218C81.1579 114.766 75.1236 115.041 68.9521 115.041V104.069C82.9407 103.932 88.2893 101.326 91.9922 92.0006H102.689V188.001H87.055Z"
    fill="#D9D9D9"
  />
  <path
    d="M189.227 158.046V143.775H175.048V136.133H189.227V121.954H196.869V136.133H211.048V143.775H196.869V158.046H189.227Z"
    fill="#D9D9D9"
  />
</svg> `;

export const ThumbnailAdult19Icon = html`
  <svg width="100%" height="100%" viewBox="0 0 280 280" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="274" height="274" rx="137" fill="#F5F5F5" />
    <rect x="3" y="3" width="274" height="274" rx="137" stroke="#D9D9D9" stroke-width="6" />
    <path
      d="M160.5 90.6286C177.094 90.6286 186.146 100.091 186.146 116.411V162.903C186.146 180.046 177.78 189.371 160.5 189.371C143.906 189.371 135.266 179.909 135.266 164.274V163.314H149.94V164.686C149.94 172.091 153.506 175.52 159.952 175.52C167.083 175.52 170.512 172.229 170.512 162.217V145.211C167.083 151.109 161.597 154.126 154.192 154.126C141.163 154.126 134.854 145.623 134.854 130.537V116.411C134.854 100.091 143.906 90.6286 160.5 90.6286ZM160.5 104.48C153.78 104.48 150.352 108.183 150.352 115.451V129.029C150.352 136.297 153.369 140.274 160.363 140.274C167.22 140.274 170.512 136.297 170.512 128.891V115.451C170.512 108.046 167.083 104.48 160.5 104.48Z"
      fill="#D9D9D9"
    />
    <path
      d="M107.386 187.863V114.08C101.489 114.629 95.4546 114.903 89.2832 114.903V103.932C103.272 103.794 108.62 101.189 112.323 91.8629H123.02V187.863H107.386Z"
      fill="#D9D9D9"
    />
  </svg>
`;

export const IconsBasicEnquadArrowChevronRightIcon = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 6 12"
  fill="none"
>
  <g clip-path="url(#clip0_5425_6148)">
    <path
      d="M0.561523 10.001C0.561523 9.89098 0.601523 9.77598 0.691523 9.69098L4.38152 6.00098L0.691523 2.31098C0.521523 2.14098 0.521523 1.86098 0.691523 1.69098C0.861523 1.52098 1.14152 1.52098 1.31152 1.69098L5.31152 5.69098C5.48152 5.86098 5.48152 6.14098 5.31152 6.31098L1.31152 10.311C1.14152 10.481 0.861523 10.481 0.691523 10.311C0.606523 10.226 0.561523 10.111 0.561523 10.001Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_5425_6148">
      <rect width="6" height="12" fill="white" />
    </clipPath>
  </defs>
</svg>`;

/**
 * https://www.figma.com/design/Top00pi5q5ylSxEviOOciV/MarppleShop-Design-System?node-id=132-1379&m=dev
 */
export const ArrowTopIcon = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 24 24"
  fill="none"
>
  <g clip-path="url(#clip0_132_1379)">
    <path
      d="M12.0002 21C11.5202 21 11.1202 20.61 11.1202 20.12V5.99001L4.61023 12.5C4.27023 12.84 3.71023 12.84 3.37023 12.5C3.03023 12.16 3.03023 11.6 3.37023 11.26L11.3802 3.26001C11.4602 3.18001 11.5602 3.11001 11.6702 3.07001C11.7702 3.03001 11.8702 3.01001 11.9802 3.01001H12.0202C12.1302 3.01001 12.2302 3.03001 12.3302 3.07001C12.4302 3.11001 12.5302 3.18001 12.6202 3.26001L20.6202 11.26C20.9602 11.6 20.9602 12.16 20.6202 12.5C20.2802 12.84 19.7202 12.84 19.3802 12.5L12.8702 5.99001V20.13C12.8702 20.61 12.4802 21.01 11.9902 21.01L12.0002 21Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_132_1379">
      <rect width="24" height="24" fill="white" />
    </clipPath>
  </defs>
</svg>`;

/**
 * https://www.figma.com/design/Top00pi5q5ylSxEviOOciV/MarppleShop-Design-System?node-id=1679-178947&m=dev
 */
export const ShareIcon = html`
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
    <g clip-path="url(#clip0_1679_178947)">
      <path
        d="M18.5 16C17.64 16 16.88 16.36 16.33 16.94L7.45 12.5C7.48 12.34 7.5 12.17 7.5 12C7.5 11.83 7.48 11.67 7.45 11.5L16.33 7.06C16.88 7.63 17.64 8 18.5 8C20.16 8 21.5 6.66 21.5 5C21.5 3.34 20.16 2 18.5 2C16.84 2 15.5 3.34 15.5 5C15.5 5.17 15.52 5.33 15.55 5.5L6.67 9.94C6.12 9.37 5.36 9 4.5 9C2.84 9 1.5 10.34 1.5 12C1.5 13.66 2.84 15 4.5 15C5.36 15 6.12 14.64 6.67 14.06L15.55 18.5C15.52 18.66 15.5 18.83 15.5 19C15.5 20.66 16.84 22 18.5 22C20.16 22 21.5 20.66 21.5 19C21.5 17.34 20.16 16 18.5 16Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1679_178947">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
`;

/**
 * https://www.figma.com/design/Top00pi5q5ylSxEviOOciV/MarppleShop-Design-System?node-id=18448-56524&t=k0KGkjoFjSOoXD6W-11
 */
export const IconsBasicArrowChevronRightIcon = html` <svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 10 10"
  fill="none"
>
  <g clip-path="url(#clip0_389_41067)">
    <path
      d="M2.96875 8.33464C2.96875 8.24297 3.00208 8.14713 3.07708 8.0763L6.15208 5.0013L3.07708 1.9263C2.93542 1.78464 2.93542 1.5513 3.07708 1.40964C3.21875 1.26797 3.45208 1.26797 3.59375 1.40964L6.92708 4.74297C7.06875 4.88464 7.06875 5.11797 6.92708 5.25963L3.59375 8.59297C3.45208 8.73464 3.21875 8.73464 3.07708 8.59297C3.00625 8.52214 2.96875 8.4263 2.96875 8.33464Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_389_41067">
      <rect width="10" height="10" fill="white" />
    </clipPath>
  </defs>
</svg>`;

export const IconsBasicArrowRightM = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="100%"
  height="100%"
  viewBox="0 0 14 14"
  fill="none"
>
  <g clip-path="url(#clip0_2614_33434)">
    <path
      d="M6.59961 1.86213C6.82819 1.63557 7.1983 1.63538 7.42676 1.86213L12.1035 6.50666C12.3776 6.779 12.3775 7.22059 12.1035 7.49299L7.42676 12.1375C7.19827 12.3644 6.82823 12.3642 6.59961 12.1375C6.37107 11.9105 6.37013 11.5423 6.59863 11.3153L10.415 7.52521H2.25391C1.96396 7.52521 1.72852 7.28977 1.72852 6.99982C1.72859 6.70994 1.964 6.47443 2.25391 6.47443H10.415L6.59863 2.68439C6.37025 2.45736 6.37109 2.08908 6.59961 1.86213Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_2614_33434">
      <rect width="14" height="14" fill="white" />
    </clipPath>
  </defs>
</svg>`;

export const IconBasicGuarantee = html`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <path
    d="M19.92 8.72C20.06 9.04 20.4 9.4 20.74 9.75L20.7477 9.75807C21.3358 10.3761 22 11.074 22 12C22 12.926 21.3358 13.6239 20.7477 14.2419L20.74 14.25L20.7384 14.2517C20.3989 14.6011 20.0498 14.9605 19.92 15.28C19.79 15.57 19.78 16.05 19.78 16.52L19.7799 16.5244C19.77 17.4033 19.7589 18.3811 19.07 19.07C18.38 19.75 17.39 19.77 16.52 19.78L16.5122 19.7802C16.0544 19.7901 15.5684 19.8007 15.28 19.92C14.96 20.06 14.6 20.4 14.25 20.74L14.2419 20.7477C13.6239 21.3358 12.926 22 12 22C11.074 22 10.3761 21.3358 9.75807 20.7477L9.75 20.74L9.74834 20.7384C9.39886 20.3989 9.0395 20.0498 8.72 19.92C8.43 19.79 7.95 19.78 7.48 19.78L7.47562 19.7799C6.59675 19.77 5.61885 19.7589 4.93 19.07C4.25 18.38 4.23 17.39 4.22 16.52L4.21983 16.5122C4.20988 16.0545 4.19932 15.5684 4.08 15.28C3.94 14.96 3.6 14.6 3.26 14.25L3.25232 14.2419C2.66421 13.6239 2 12.926 2 12C2 11.074 2.66421 10.3761 3.25232 9.75807L3.26 9.75L3.26161 9.74835C3.6011 9.39887 3.9502 9.0395 4.08 8.72C4.21 8.43 4.22 7.95 4.22 7.48L4.22005 7.47518C4.23004 6.59639 4.24126 5.60876 4.93 4.93C5.62 4.25 6.61 4.23 7.48 4.22L7.48783 4.21983C7.94555 4.20988 8.43164 4.19932 8.72 4.08C9.04 3.94 9.4 3.6 9.75 3.26L9.75807 3.25232C10.3761 2.66421 11.074 2 12 2C12.926 2 13.6239 2.66421 14.2419 3.25232L14.25 3.26L14.2517 3.26161C14.6011 3.6011 14.9605 3.95021 15.28 4.08C15.57 4.21 16.05 4.22 16.52 4.22L16.5248 4.22005C17.4036 4.23004 18.3912 4.24126 19.07 4.93C19.75 5.62 19.77 6.61 19.78 7.48L19.7802 7.48785C19.7901 7.94557 19.8007 8.43165 19.92 8.72Z"
    fill="#1C75FF"
  />
  <path
    d="M16.74 10.09L11.77 15.29C11.58 15.49 11.32 15.6 11.05 15.6C10.78 15.6 10.52 15.49 10.33 15.29L7.25999 12.08C6.87999 11.68 6.88999 11.05 7.28999 10.67C7.68999 10.29 8.31999 10.3 8.69999 10.7L11.05 13.15L15.3 8.71004C15.68 8.31004 16.32 8.30004 16.71 8.68004C17.11 9.06004 17.12 9.69004 16.74 10.09Z"
    fill="white"
  />
</svg>`;
